import { localizationFetch } from "./localizationClient.js";

/**
 * GET /api/localization/language — returns array of { code, name, nameRefId, translations? }
 */
export async function getLanguages({ codes, langCodes } = {}, init) {
    const params = {};
    if (codes?.length) params.codes = codes;
    if (langCodes?.length) params.langCodes = langCodes;
    return localizationFetch("/api/localization/language", { params, ...(init || {}) });
}

/**
 * GET /api/localization/project
 */
export async function getProjects({ search } = {}, init) {
    const params = {};
    if (search?.trim()) params.search = search.trim();
    return localizationFetch("/api/localization/project", { params, ...(init || {}) });
}

/**
 * GET /api/localization/version
 */
export async function getVersions({ project, search } = {}, init) {
    const params = {};
    if (project?.trim()) params.project = project.trim();
    if (search?.trim()) params.search = search.trim();
    return localizationFetch("/api/localization/version", { params, ...(init || {}) });
}

/**
 * POST /api/localization/translate/search
 */
export async function searchTranslations(payload, init) {
    return localizationFetch("/api/localization/translate/search", {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

/**
 * POST /api/localization/translate/new
 */
export async function createTranslation(payload, init) {
    return localizationFetch("/api/localization/translate/new", {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

/**
 * PATCH /api/localization/translate/{trId}
 */
export async function patchTranslation(trId, payload, init) {
    return localizationFetch(`/api/localization/translate/${trId}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

/**
 * PUT /api/localization/translate/{trId}/{langCode}
 */
export async function upsertTranslationValue(trId, langCode, payload, init) {
    return localizationFetch(`/api/localization/translate/${trId}/${encodeURIComponent(langCode)}`, {
        method: "PUT",
        body: payload,
        ...(init || {}),
    });
}

/**
 * DELETE /api/localization/translate/{trId}
 */
export async function deleteTranslation(trId, init) {
    return localizationFetch(`/api/localization/translate/${trId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}

export const LocalizationApi = {
    getLanguages,
    getProjects,
    getVersions,
    searchTranslations,
    createTranslation,
    patchTranslation,
    upsertTranslationValue,
    deleteTranslation,
};
